var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center border-0"},[_c('b-card',{staticClass:"no-inventory",attrs:{"bg-variant":"secondary","text-variant":"dark"}},[_c('b-card-text',[_c('p',{staticClass:"h4"},[_vm._v(_vm._s(_vm.infoTitle))]),_c('p',{staticClass:"pt-3",domProps:{"innerHTML":_vm._s(this.staticInfoText)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }